import moment from 'moment';

export const getChipsLabel = (chipsSettings, key, value) => {
  const { prefix, type } = chipsSettings[key] || {};

  let label = prefix ? `${prefix}: ` : '';
  if (type === 'date') {
    label += value ? moment(value).format('MM/DD/YY') : '';
  } else {
    label += value;
  }
  return label;
};
